interface YouTubeEmbedProps {
  videoId: string
  title?: string
  isShort?: boolean
  className?: string
  iframeClassName?: string
}

export default function YouTubeEmbed({
  videoId,
  title,
  isShort = false,
  className = '',
  iframeClassName = '',
}: YouTubeEmbedProps) {
  const aspectClass = isShort ? 'aspect-[9/16] max-h-[400px]' : 'aspect-video'

  return (
    <div
      className={`overflow-hidden rounded-xl bg-black shadow-md ${className}`}
    >
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title ?? 'YouTube video'}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
        className={`block w-full border-0 ${aspectClass} ${iframeClassName}`}
      />
    </div>
  )
}
